import React from "react";

import styles from "./UserView.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import UserProfile from "../../components/UserProfile/UserProfile";

const UserView = () => {
  return (
    <div className={styles.container}>
      <Navbar />
      <div className={styles.containerTitle}>
        <UserProfile />
      </div>
      <Footer />
    </div>
  );
};

export default UserView;
